// import {Suspense, useRef, useEffect, useRef, useState,} from 'react'
import {Perf} from 'r3f-perf'
import {useControls} from 'leva'
import {Room} from './Room.jsx'
import {DayNightDebug} from './DayNightDebug.jsx'
import {SquareMask} from './SquareMask.jsx'
import {TreeModel} from './TreeModel.jsx'
// import {Placeholder} from './Placeholder.jsx'
// import {EffectComposer, Pixelation, ToneMapping} from '@react-three/postprocessing'

export function Experience() {

    /*const {
        // pixelation,
        timeDebug,
    } = useControls('Room', {
        // pixelation: false,
        timeDebug: true,
    })*/

    return <>
        {/*<Perf
            position='bottom-right'
            style={{
                'zIndex': 0
            }}
        />*/}

        {/*<Suspense*/}
        {/*    fallback={<Placeholder scale={3}/>}*/}
        {/*>*/}
        {/*<EffectComposer>*/}
        {/*    <ToneMapping mode={0}/>*/}
        {/*    <Pixelation granularity={3 * pixelation}/>*/}
        {/*</EffectComposer>*/}

        {/*<Sky distance={450000} sunPosition={[0, 1, 0]} inclination={0} azimuth={0.25}/>*/}

        <Room
            scale={3}
            position-y={-2}
        />

        <SquareMask id={1} rotation={[0, Math.PI, 0]} position={[-4.77, 5.5, 10]}/>
        <SquareMask id={2} rotation={[0, -Math.PI / 2, 0]} position={[16.6, 5.5, 1.53]}/>
        <TreeModel id={1} scale={[0.7, 1, 0.7]} position={[-5, 0, 20]}/>
        <TreeModel id={2} rotation-y={0.67} scale={[0.7, 1, 0.7]} position={[22, 0, 1]}/>

        {/*<DayNightDebug visible={timeDebug} position={[0, 10, 0]}/>*/}
        <DayNightDebug visible={false} position={[0, 10, 0]}/>
        {/*</Suspense>*/}
    </>
}